import realpressQuickSetupNotification from './setup/quick-setup-notification';
import realpressDropDownPage from './mixins/wp-dropdown-page';
import realpressTomSelect from '../mixins/tom-select';


document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressQuickSetupNotification();
	realpressDropDownPage();
	realpressTomSelect();
} );
